<template>
  <div class="clients">

  <Hider :initiallyVisible="true">
    <template v-slot:label>Carte</template>
  <div style="height: 36em; width: 100%">
    <div v-if="false" class="info" style="height: 15%">
      <span>Center: {{ center }}</span>
      <span>Zoom: {{ zoom }}</span>
      <span>Bounds: {{ bounds }}</span>
    </div>
    <l-map
      style="height: 80%; width: 100%"
      :zoom="zoom"
      :center="center"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @update:bounds="boundsUpdated"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-marker v-for="{nom, location} in realClients" :lat-lng="location" :key="nom">
        <l-popup>{{ nom }}</l-popup>
      </l-marker>
    </l-map>
  </div>
  </Hider>
  <h1>{{ clients.length }} Client(s)</h1>
    <SortedTable :values="clients" sort="numero">
      <thead>
        <tr>
          <th scope="col" style="text-align: left; width: 10rem;">
            <SortLink name="nom">Nom</SortLink>
          </th>
          <th scope="col" style="text-align: left; width: 10rem;">
            <SortLink name="numero">Numero</SortLink>
          </th>
          <th scope="col" style="text-align: left; width: 10rem;">
            <SortLink name="ville">Ville</SortLink>
          </th>
          <th scope="col" style="text-align: left; width: 10rem;">
            <SortLink name="location">Localized</SortLink>
          </th>
        </tr>
      </thead>
      <tbody slot="body" slot-scope="sort">
        <tr v-for="c in sort.values" :key="c.numero">
          <td>
            <Router-Link :to="{ name: 'client', params: {id: c.numero} }">{{ c.nom }}</Router-Link>
          </td>
          <td>{{ c.numero }}</td>
          <td>{{ c.ville }}</td>
          <td>{{ c.location ? 'yes' : 'no' }}</td>
        </tr>
      </tbody>
    </SortedTable>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, } from 'vue2-leaflet'
import Hider from '@/components/base/Hider.vue';
import { getClients } from '@/lib/databases.js';
import { getGeolocation } from '@/lib/geoloc.js';

export default {
components: { LMap, LTileLayer, LMarker, LPopup, Hider, },
mounted () {
    console.log("clients view mounted");
        let { customers } = this.$db;
        let setClients = (clients) => { this.clients = clients };
        getClients(customers, setClients);
    },
data () { return {
filter:'',
clients: [],
box: {
min: [48.978329, 2.467863],
max: [48.939337, 2.663118],
},
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors feat. Lebobo',
      radius: 20,
      color: 'red',
      zoom: 12,
      center: [48.945, 2.548206],
      bounds: null
}; },
    computed: {
     realClients () {
return this.clients
.filter(c => c.location)
.map(c => { let { nom, location } = c; return { nom, location }})
     },
},
  methods: {
    getGeolocation() {
      let self = this
      let setGeo = ({lat, lon}) => { self.geo = { lat, lon }}
      return getGeolocation(this.lieu, setGeo)
     },
    resume (id) {
      this.$db.customers.get(id).then(_ => console.table(_.client)).catch(console.log);
    },
    zoomUpdated (zoom) {
      this.zoom = zoom;
    },
    centerUpdated (center) {
      this.center = center;
    },
    boundsUpdated (bounds) {
      this.bounds = bounds;
    },
    }
}
</script>

<style>
  #carte {
  }

  #carte .osm {
  border : thin solid black;
  }

.info { display: none }
</style>
